import { useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { Plus } from "lucide-react";
import { setHeading, setText } from "../constants/typography";
import Reveal from "./ui/Reveal";
import styles from "../styles/FAQ.module.scss";
import { CONTENT } from "../constants/content";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const reduceMotion = useReducedMotion();

  const faqData = CONTENT.faq;

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={styles.faqSection} id="faq" aria-label="Domande frequenti">
      <div className={styles.inner}>
        <div className={styles.aside}>
          <Reveal>
            <span className={styles.eyebrow}>FAQ</span>
            <h2 className={styles.title}>{setHeading(faqData.title)}</h2>
            <p className={styles.subtitle}>{setText(faqData.subtitle)}</p>
          </Reveal>
        </div>

        <div className={styles.faqList}>
          {faqData.questions.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <Reveal
                key={index}
                className={`${styles.faqItem} ${isOpen ? styles.open : ""}`}
                delay={Math.min(index, 4) * 0.05}
                amount={0.3}
              >
                <h3 className={styles.questionHeading}>
                  <button
                    id={`faq-trigger-${index}`}
                    className={styles.faqQuestion}
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${index}`}
                    type="button"
                  >
                    <span>{setHeading(item.question)}</span>
                    <Plus className={styles.icon} aria-hidden="true" />
                  </button>
                </h3>

                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      id={`faq-panel-${index}`}
                      role="region"
                      aria-labelledby={`faq-trigger-${index}`}
                      className={styles.faqAnswer}
                      initial={reduceMotion ? false : { height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={reduceMotion ? { opacity: 0 } : { height: 0, opacity: 0 }}
                      transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
                    >
                      <p>{setText(item.answer)}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
